var React = require('react');

function SortDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.0635 5.80865C14.0257 5.71729 13.9616 5.6392 13.8794 5.58426C13.7971 5.52932 13.7005 5.5 13.6016 5.5H3.60156C3.50267 5.5 3.406 5.52932 3.32378 5.58427C3.24155 5.63921 3.17746 5.7173 3.13962 5.80866C3.10178 5.90003 3.09188 6.00056 3.11117 6.09755C3.13047 6.19455 3.17809 6.28364 3.24802 6.35356L8.24802 11.3535C8.29445 11.4 8.34956 11.4368 8.41023 11.4619C8.47089 11.4871 8.5359 11.5 8.60157 11.5C8.66723 11.5 8.73224 11.4871 8.7929 11.4619C8.85357 11.4368 8.90869 11.4 8.95511 11.3535L13.9551 6.35356C14.025 6.28364 14.0727 6.19454 14.092 6.09755C14.1113 6.00056 14.1014 5.90002 14.0635 5.80865Z"}));
}

SortDown.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = SortDown;

SortDown.default = SortDown;
